import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Expanding Universe",
  date: new Date(2024, 7, 25),
  img: "/img/universe.jpeg",
  video: "/videos/universe.mp4",
  tracks: [
    {
      title: "Punkin' Spice",
      src: "/songs/2024-08-25/punkin_spice.mp3",
      duration: 548.4,
    },
    {
      title: "Horseback Riders",
      src: "/songs/2024-08-25/horseback_riders.mp3",
      duration: 560.664,
    },
    {
      title: "Margin Of Error",
      src: "/songs/2024-08-25/margin_of_error.mp3",
      duration: 765.312,
    },
    {
      title: "Clarifly",
      src: "/songs/2024-08-25/clarifly.mp3",
      duration: 1289.208,
    },
    {
      title: "Dancing Treefrogs",
      src: "/songs/2024-08-25/dancing_treefrogs.mp3",
      duration: 1210.32,
    },
    {
      title: "Carnival Games",
      src: "/songs/2024-08-25/carnival_games.mp3",
      duration: 416.016,
    },
    {
      title: "Down & Dirty",
      src: "/songs/2024-08-25/down_and_dirty.mp3",
      duration: 1341.072,
    },
    {
      title: "Outhibition",
      src: "/songs/2024-08-25/outhibition.mp3",
      duration: 437.328,
    },
    {
      title: "Smoke Break",
      src: "/songs/2024-08-25/smoke_break.mp3",
      duration: 1464.72,
    },
  ],
};
export default album;
